import { render } from "./Root.vue?vue&type=template&id=d4d419c8"
import script from "./Root.vue?vue&type=script&lang=js"
export * from "./Root.vue?vue&type=script&lang=js"

import "./Root.vue?vue&type=style&index=0&id=d4d419c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Root.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4d419c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4d419c8', __exports__)) {
    api.reload('d4d419c8', __exports__)
  }
  
  module.hot.accept("./Root.vue?vue&type=template&id=d4d419c8", () => {
    api.rerender('d4d419c8', render)
  })

}


export default __exports__